<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  reset: []
}>()

const { t } = useI18n()
</script>

<template>
  <OButton
    v-if="visible"
    size="M"
    :label="t('reset_all')"
    variant="tertiary"
    dataTestid="reset-filters-btn"
    class="whitespace-nowrap"
    @click="emit('reset')"
  />
</template>
